module.exports = __webpack_public_path__ + "static/media/inIcon.5a80710d.svg";